<div class="widget-container">
  <ion-grid>
    <ion-row class="close-row">
      <ion-col (click)="close()" class="close-col">
        <img src="../../../assets/icon/cancel.svg" alt="">
      </ion-col>
    </ion-row>

    <div>
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            <label> {{ 'Machine Library ISO 12100' | translate}} </label> <label class="subTitle">(Access
              {{ 'access_denied' | translate }})</label>
          </div>
          <div style="margin-top: 8px;"><label class="c-stepper__title">{{ 'insufficient_privileges_view_project_details' | translate }}</label>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <p class="textLabel"> {{ 'reason_for_request_access_optional' | translate }}</p>
      </ion-row>
      <ion-textarea rows="5" class="proDescription">
      </ion-textarea>
      <p class="textSubLabel">{{ 'request_access_status_note' | translate }}</p>
      <ion-row class="button-row">
        <button class="canButton"> {{ 'Cancel' | translate}}</button>
        <ion-col></ion-col>
        <ion-col></ion-col>
        <button position="bottom" (click)="dismissModal()"> {{ 'Request Access' | translate}}</button>
      </ion-row>
    </div>
  </ion-grid>
</div>